/*
===== All ad units & sizes from BidBarrel defintion object (7/12/21) =====
=================== Not all are used / should be used ====================
leader-plus-top - [728,90],[970,90],[970,66]
leader-middle - [728,90],[970,66]
leader-inc - [728,90],[970,90]
leader-bottom - [728,90],[970,66]
leader-plus-lazy-bottom - [728,90],[970,250],[970,66],[970,90]
leaderboard-inc - [728,90]
leaderboard-lazy-bottom - [728,90],[970,90]
mpu-top - [300,250]
mpu-plus-top - [300,250],[300,600]
mpu-bottom - [300,250]
mpu-inc - [300,250]
mpu-lazy-bottom - [300,250]
mpu-flex-incremental - [300,250],[11,11],fluid]
mpu-plus-lazy-bottom - [300,250],[300,600]
mobile-omni-skybox-plus-sticky - [6,6],[320,50],[5,5]
mobile-skybox-plus-sticky - [320,50],[5,5]
mobile-skybox-plus-top - [6,6],[320,50],[5,5]
mobile-banner-top - [320,50]
mobile-banner-middle - [320,50]
mobile-banner-inc - [320,50]
mobile-banner-plus-inc - [300,250],[320,50]
mobile-banner-lazy-middle - [320,50]
mobile-banner-lazy-bottom - [320,50]
mobile-mpu-top - [300,250]
mobile-mpu-plus-top - [300,250, 300,50]
mobile-mpu-middle - [300,250]
mobile-mpu-bottom - [300,250]
mobile-mpu-flex-lazy-bottom - [300,250],[320,50]
mobile-native-top - [11,11],fluid]
mobile-native-flex-top - [300,250],fluid,[11,11]
omni-skybox-leader-sticky - [6,6],[728,90],[970,66],[5,5]
skybox-leader-sticky - [728,90],[970,66],[5,5]
skybox-plus-top - [728,90],[970,90],[970,66],[5,5]
skyscraper-top - [160,600]
native-top - [11,11],fluid]
native-flex-middle - [300,250],fluid,[11,11]
native-flex2-middle - [728,90],fluid,[11,11]
rectangle-top - [180,150]
outofpage - [1,1]
*/

export enum AdType {
  DesktopLeaderboardInc = 'leaderboard-inc',
  DesktopMPUInc = 'mpu-inc',

  MobileBannerInc = 'mobile-banner-inc',
  MobileBannerFlexInc = 'mobile-banner-plus-inc',

  /**
   * Special unit that Should only be defined at-most, once per page.
   */
  OutOfPage = 'intromercial',

  DesktopSkybox = 'omni-skybox-leader-sticky',
  DesktopLeaderboardBottom = 'leaderboard-lazy-bottom',
  DesktopMPUPlusTop = 'mpu-plus-top',

  MobileSkybox = 'mobile-omni-skybox-plus-sticky',
  MobileMPUPlusTop = 'mobile-mpu-plus-top',
  MobileBannerBottom = 'mobile-banner-lazy-bottom'
}

type TAdSize = [number, number];

const DestkopLeaderboardMinSize: TAdSize = [728, 90];
const MobileBannerMinSize: TAdSize = [320, 50];
const MPUMinSize: TAdSize = [300, 250];

export const MinimumAdSize = new Map<AdType, TAdSize>([
  [AdType.DesktopLeaderboardInc, DestkopLeaderboardMinSize],
  [AdType.DesktopMPUInc, MPUMinSize],
  [AdType.DesktopMPUPlusTop, MPUMinSize],
  [AdType.DesktopLeaderboardBottom, DestkopLeaderboardMinSize],

  [AdType.MobileMPUPlusTop, MPUMinSize],
  [AdType.MobileBannerBottom, MobileBannerMinSize],
  [AdType.MobileBannerInc, MobileBannerMinSize],
  [AdType.MobileBannerFlexInc, MobileBannerMinSize]
]);

// Unused units in React
// MinimumAdSize.set('leader-plus-top', DestkopLeaderboardMinSize); // this is as tall as the tallest size but in my testing it was filled with 90 like 90% of time. Min size is 66
// MinimumAdSize.set('leader-inc', DestkopLeaderboardMinSize);
// MinimumAdSize.set('mpu-lazy-bottom', MPUMinSize);
// MinimumAdSize.set('mobile-banner-top', MobileBannerMinSize);
// MinimumAdSize.set('mobile-banner-plus-inc', MobileBannerMinSize);
// MinimumAdSize.set('mobile-mpu-flex-lazy-bottom', MPUMinSize);
// MinimumAdSize.set("mobile-banner-lazy-middle", MobileBannerMinSize);
// MinimumAdSize.set("mobile-banner-middle", MobileBannerMinSize);
// MinimumAdSize.set("mobile-mpu-top", MPUMinSize);
// MinimumAdSize.set("mobile-mpu-middle", MPUMinSize);
// MinimumAdSize.set("mobile-mpu-bottom", MPUMinSize);
// MinimumAdSize.set("mpu-plus-lazy-bottom", MPUMinSize);
// MinimumAdSize.set("leader-plus-lazy-bottom", 66);
// MinimumAdSize.set("mpu-flex-incremental", MPUMinSize);
// MinimumAdSize.set("mpu-bottom", MPUMinSize);
// MinimumAdSize.set("mpu-top", MPUMinSize);
// MinimumAdSize.set("leader-middle", 66);
// MinimumAdSize.set("leader-bottom", 66);
// MinimumAdSize.set("skyscraper-top", 600);
